import React from 'react'
import { Box, Text, Link } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { Article } from '@leid/api-articles'
import { getDirectionLink } from 'utils/locations'
import { Location } from '@leid/api-locations'

type Props = {
  masterArticle: Article | undefined
  relatedArticle: Article | undefined
  location?: Location
}
const Quicklinks = ({ masterArticle, relatedArticle, location }: Props) => {
  const { t } = useTranslation()

  return (
    <Box marginTop="10px" display="flex" flexDirection="column" gap={2}>
      <Text fontSize="md" fontWeight="semibold">
        {t('quicklinks')}
      </Text>
      <Link href="#technical-details" fontSize="sm" fontWeight="normal" textDecoration="underline">
        {t('viewTechnicalDetails')}
      </Link>
      {masterArticle && (
        <Link href={'#how-to-pick-up-the-product'} fontSize="sm" fontWeight="normal" textDecoration="underline">
          {t('howToPickup')}
        </Link>
      )}
      {relatedArticle && (
        <Link href={'#product-instructions'} fontSize="sm" fontWeight="normal" textDecoration="underline">
          {t('productInstructions')}
        </Link>
      )}
      {location && (
        <Link
          href={getDirectionLink(location)}
          target="_blank"
          fontSize="sm"
          fontWeight="normal"
          textDecoration="underline"
        >
          {t('getDirections')}
        </Link>
      )}
    </Box>
  )
}

export default Quicklinks
